import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.promise.finally.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { mergeSort } from '../../../base/common/arrays.js';
import { CancellationToken } from '../../../base/common/cancellation.js';
import { illegalArgument, onUnexpectedExternalError } from '../../../base/common/errors.js';
import { URI } from '../../../base/common/uri.js';
import { registerLanguageCommand } from '../../browser/editorExtensions.js';
import { CodeLensProviderRegistry } from '../../common/modes.js';
import { IModelService } from '../../common/services/modelService.js';
import { DisposableStore } from '../../../base/common/lifecycle.js';
export var CodeLensModel = /*#__PURE__*/function () {
  function CodeLensModel() {
    _classCallCheck(this, CodeLensModel);

    this.lenses = [];
    this._disposables = new DisposableStore();
  }

  _createClass(CodeLensModel, [{
    key: "dispose",
    value: function dispose() {
      this._disposables.dispose();
    }
  }, {
    key: "add",
    value: function add(list, provider) {
      this._disposables.add(list);

      var _iterator = _createForOfIteratorHelper(list.lenses),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var symbol = _step.value;
          this.lenses.push({
            symbol: symbol,
            provider: provider
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return CodeLensModel;
}();
export function getCodeLensData(model, token) {
  var provider = CodeLensProviderRegistry.ordered(model);
  var providerRanks = new Map();
  var result = new CodeLensModel();
  var promises = provider.map(function (provider, i) {
    providerRanks.set(provider, i);
    return Promise.resolve(provider.provideCodeLenses(model, token)).then(function (list) {
      return list && result.add(list, provider);
    }).catch(onUnexpectedExternalError);
  });
  return Promise.all(promises).then(function () {
    result.lenses = mergeSort(result.lenses, function (a, b) {
      // sort by lineNumber, provider-rank, and column
      if (a.symbol.range.startLineNumber < b.symbol.range.startLineNumber) {
        return -1;
      } else if (a.symbol.range.startLineNumber > b.symbol.range.startLineNumber) {
        return 1;
      } else if (providerRanks.get(a.provider) < providerRanks.get(b.provider)) {
        return -1;
      } else if (providerRanks.get(a.provider) > providerRanks.get(b.provider)) {
        return 1;
      } else if (a.symbol.range.startColumn < b.symbol.range.startColumn) {
        return -1;
      } else if (a.symbol.range.startColumn > b.symbol.range.startColumn) {
        return 1;
      } else {
        return 0;
      }
    });
    return result;
  });
}
registerLanguageCommand('_executeCodeLensProvider', function (accessor, args) {
  var resource = args.resource,
      itemResolveCount = args.itemResolveCount;

  if (!(resource instanceof URI)) {
    throw illegalArgument();
  }

  var model = accessor.get(IModelService).getModel(resource);

  if (!model) {
    throw illegalArgument();
  }

  var result = [];
  var disposables = new DisposableStore();
  return getCodeLensData(model, CancellationToken.None).then(function (value) {
    disposables.add(value);
    var resolve = [];

    var _iterator2 = _createForOfIteratorHelper(value.lenses),
        _step2;

    try {
      var _loop = function _loop() {
        var item = _step2.value;

        if (typeof itemResolveCount === 'undefined' || Boolean(item.symbol.command)) {
          result.push(item.symbol);
        } else if (itemResolveCount-- > 0 && item.provider.resolveCodeLens) {
          resolve.push(Promise.resolve(item.provider.resolveCodeLens(model, item.symbol, CancellationToken.None)).then(function (symbol) {
            return result.push(symbol || item.symbol);
          }));
        }
      };

      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return Promise.all(resolve);
  }).then(function () {
    return result;
  }).finally(function () {
    // make sure to return results, then (on next tick)
    // dispose the results
    setTimeout(function () {
      return disposables.dispose();
    }, 100);
  });
});